import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M10.9986 11.0044V5.00109C6.05786 5.00109 2.15731 9.48355 3.15745 14.6063C3.76754 17.728 6.27789 20.2394 9.39834 20.8497C14.7491 21.8903 18.9997 17.3378 18.9997 13.0055H12.9989C11.8987 13.0055 10.9986 12.115 10.9986 11.0044ZM9.77839 18.8887C7.44806 18.4384 5.57779 16.5674 5.11773 14.2261C4.35762 10.314 7.36805 7.74259 8.99828 7.17228V11.0044C8.99828 13.2156 10.7885 15.0066 12.9989 15.0066H16.6594C15.7993 17.0777 13.2389 19.569 9.77839 18.8887ZM14.9991 11.0044H21C21 6.58196 17.4195 3 12.9989 3V9.00328C12.9989 10.1139 13.899 11.0044 14.9991 11.0044ZM14.9991 5.17119C16.6994 5.77152 18.0496 7.30235 18.6597 9.00328H14.9991V5.17119Z' />
        </SvgIcon>
    );
});
